<ng-container *ngIf="initialized">
  <form class="form" #myForm="ngForm" (ngSubmit)="save()" novalidate>
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="!mergeWith || mergeWith.length == 0" class="modal-title" id="exampleModalLabel">Convert To Event</h5>
        <h5 *ngIf="mergeWith && mergeWith.length > 0" class="modal-title" id="exampleModalLabel">Combine & Convert To Event</h5>
      </div>
      <div class="modal-body">
        <div *ngIf="mergeWith && mergeWith.length > 0" class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="exampleFormControlInput1">Paper 1 Title</label>
              <input class="form-control" readonly [(ngModel)]="paper.title" required [name]="'mergePaperTitle'" />
            </div>
          </div>
          <div *ngFor="let mergePaper of mergeWith; let idx = index" class="col-md-12">
            <div class="form-group">
              <label for="exampleFormControlInput1">Paper {{ idx + 2 }} Title</label>
              <input class="form-control" readonly [(ngModel)]="mergePaper.title" required [name]="'mergePaperTitle' + idx" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <div class="form-group">
              <label for="exampleFormControlInput1">Title</label>
              <input class="form-control" [(ngModel)]="model.title" required name="title" />
              <div class="invalid-message">
                <div>Title is required</div>
              </div>
            </div>
            <div class="form-group">
              <label class="mr-1" for="url">Duration (Mins):</label>
              <kendo-numerictextbox class="form-control" required [step]="5" format="n" [(ngModel)]="model.durationInMins" name="durationInMins"></kendo-numerictextbox>
              <div class="invalid-message">
                <div>Duration is required</div>
              </div>
            </div>
            <div class="form-group">
              <label class="mr-1" for="url">Day:</label>
              <select class="form-control" (change)="updateDay($event)" [(ngModel)]="model.dayIndex" name="dayIndex">
                <option *ngFor="let day of dayLabels; let idx = index" [value]="idx">{{ day }}</option>
              </select>

              <div class="invalid-message">
                <div>Day is required</div>
              </div>
            </div>
            <div class="form-group">
              <label class="mr-1" for="url">Room:</label>
              <select class="form-control" required [(ngModel)]="model.roomId" name="roomId">
                <option *ngFor="let room of roomsToDisplay; let idx = index" [value]="room.id">{{ room.roomName }}</option>
              </select>

              <div class="invalid-message">
                <div>Room is required</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row no-gutters">
          <div class="col-md-12">
            <button class="btn btn-sm btn-admin-primary mr-2" [promiseBtn]="submitComplete" type="submit">Convert</button>
            <button class="btn btn-sm btn-outline-dark" (click)="onCancel()" type="button">Cancel</button>
          </div>
        </div>
      </div>
    </div>
  </form>
</ng-container>
